/**
 * Copyright IBM Corp. 2022, 2026
 */

import { vercelSplit } from '@web/cms'
import HDSTable from 'components/hds-table'
import s from './style.module.css'

export default function Table({ table }: { table: string }) {
	return (
		<div className={s.tableBlock}>
			<HDSTable table={vercelSplit(table)} />
		</div>
	)
}
